import { _ } from "extensions/underscore";
    
import { Presenter } from "common/components/table/cells/generic";

export class ActionPresenter extends Presenter {
    // eslint-disable-next-line class-methods-use-this
    contentTemplate = ({ tooltip }) => `<a href="#" data-toggle="tooltip" data-placement="top" title="${tooltip.replace(/ /g, "&nbsp;")}">${tooltip}</a>`;
    
    itemContent(column, content) {
        const cellOptionsMap = _.propValue(column, "cellOptions.map") || {};
        const mapProp = _(cellOptionsMap).findWhere({ value: content }) || {};
        
        return this.contentTemplate({
            tooltip: mapProp.tooltip || ""
        });
    }
}
